import { render, staticRenderFns } from "./IdeaScoreTestTopNavigation.vue?vue&type=template&id=705781c4&scoped=true"
import script from "./IdeaScoreTestTopNavigation.vue?vue&type=script&lang=js"
export * from "./IdeaScoreTestTopNavigation.vue?vue&type=script&lang=js"
import style0 from "./IdeaScoreTestTopNavigation.vue?vue&type=style&index=0&id=705781c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705781c4",
  null
  
)

export default component.exports